import React, { useEffect, useState } from "react";
import servicosAtribuicao from "../../servicos/servicos-atribuicao";
import servicosColaborador from "../../servicos/servicos-colaborador";
import servicosMotivo from "../../servicos/servicos-motivo";
import MenuLateral from "./MenuLateral";
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import NavMenu from "./Nav";
import { ToastContainer, toast } from 'react-toastify';
import CheckAll from "../../img/svgs/CheckAll";
import Salvar from "../../img/svgs/Salvar";

const dadosAtribuicao = {
    "id_colaborador": 0,
    "id_motivo": 0,
    "data": new Date()
}

const AtribuicaoMilhasEventos = () => {
    const [colaboradores, setColaboradores] = useState([]);
    const [motivos, setMotivos] = useState(null);
    const [data, setData] = useState(dadosAtribuicao);
    const [listaFiltrada, setListaFiltrada] = useState([]);
    const [filtroGerentes, setFiltroGerente] = useState(false);


    useEffect(() => {
        let listaCargosFiltro = ['GERENTE COMERCIAL', 'GERENTE REGIONAL', 'SUPERINTENDENCIA'];
        function getDados() {

            servicosColaborador.listarTodos()
                .then(response => {
                    let listaGerentes = [];
                    let listaColaboradores = [];
                    if (response.status === 200) {
                        response.data.map(colaborador => {
                            if (listaCargosFiltro.includes(String(colaborador.Cargo[0].nome_cargo).trim()) && String(colaborador.Setor[0].nome_setor).trim() === 'COMERCIAL') {
                                return listaGerentes.push(colaborador);
                            } else {
                                return listaColaboradores.push(colaborador);
                            }
                        })

                    }
                    if (filtroGerentes === true) {
                        setColaboradores(listaGerentes);

                    } else {
                        setColaboradores(listaColaboradores);

                    }
                }).catch((error) => {
                    console.log(error);
                });
        }
        getDados();
    }, [filtroGerentes, listaFiltrada]);

    useEffect(() => {
        function getDados() {
            servicosMotivo.listarTodos()
                .then(response => {
                    if (response.status === 200) {
                        setMotivos(response.data);
                    }
                }).catch((error) => {
                    console.log(error);
                });

        }
        getDados()
    }, []);

    const handleChange = (e) => {
        let { name, value } = e.target;
        if (name === 'id_colaborador' || name === "id_motivo") {
            value = Number(value);
        }
        setData({ ...data, [name]: value });

    }


    const handlePesquisa = (e) => {
        const pesquisa = e.target.value;
        let listaAtualizada = [];
        if (pesquisa !== "") {
            listaAtualizada = colaboradores.filter((item) => {
                return String(item.nome).toLowerCase().indexOf(pesquisa.toLowerCase()) !== -1;
            })
            setListaFiltrada(listaAtualizada);
        } else {
            setListaFiltrada(colaboradores);
        }

    }

    const handleFiltro = () => {
        const elementoWeb = document.querySelector(`#filtro_gerentes`);
        if (elementoWeb?.checked === true) {
            setFiltroGerente(true);
        } else {
            setFiltroGerente(false);
        }
    }

    const SelectMotivos = () => {
        if (motivos === null) {
            return <>Carregando lista de motivos</>
        }
        return (
            <>
                <label htmlFor="id_motivo" className="form-label mb-3 me-2">Motivo</label>
                <select className="form-select w-50 mb-3 rounded-5 " name="id_motivo" onChange={handleChange} aria-label="" defaultValue={data.id_motivo}>
                    <option value={0}>Selecione</option>
                    {motivos.map((item) => {
                        const id = item.id_motivo;
                        return <option key={id} value={id}>{item.descricao}</option>
                    })}
                </select>
            </>
        )
    }


    const selecionarTodos = () => {
        colaboradores.forEach(colaborador => {
            const elementoWeb = document.querySelector(`#evento${colaborador.id_colaborador}`);
            if (elementoWeb?.checked === true) {
                elementoWeb.checked = false;
            } else {
                elementoWeb.checked = true;
            }
        });
    }

    const atribuicaoMultipla = async () => {
        if (data.id_motivo > 0) {
            const listaSelecionados = [];
            colaboradores.forEach(colaborador => {
                const elementoWeb = document.querySelector(`#evento${colaborador.id_colaborador}`);
                if (elementoWeb?.checked === true) {
                    listaSelecionados.push(elementoWeb)
                }
            });


            for (const i of listaSelecionados) {
                const dataAtribuicao = {
                    "id_colaborador": Number(i.value),
                    "id_motivo": data?.id_motivo,
                    "data": new Date()
                }
                servicosAtribuicao.create(dataAtribuicao)
                    .then(response => {
                        if (response.status === 201) {
                            i.checked = false;
                        }
                    })
                    .catch(e => {
                        console.log(e);
                        toast.error(`Erro ao tentar atribuir milhas para o id ${i.value} `);
                    })

            }

            toast('Finalizado atribuição');
        } else {
            toast.error(`Por favor selecione um motivo válido `);

        }
    }
    return <>
        <NavMenu />
        <ToastContainer />
        <div className="d-flex container">
            <div className="w-25">
                <MenuLateral />
            </div>

            <div className="w-75">
                <div className="sob-tabelas">
                    <div className="d-flex align-items-center col ">
                        <SelectMotivos />
                        <h3 className="mb-5 ms-3  subtitulo">Atribuição por Evento</h3>
                    </div>
                    <div className="d-flex">
                        <span className="">Busca:</span> <input
                            className="mb-3 ms-2 rounded-5"
                            type="text"
                            id="pesquisa"
                            onChange={handlePesquisa}
                        />
                        <Form.Check
                            type="switch"
                            className="ms-5"
                            id='filtro_gerentes'
                            label="SUP-GR-GC"
                            onChange={handleFiltro}
                        />
                    </div>
                </div>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Participação <button className="rounded p-1 btn-icones" onClick={selecionarTodos}> <CheckAll /><span> Todos</span></button></th>
                            <th>Cargo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listaFiltrada.length > 0 ? (listaFiltrada.map(colaborador => (
                                <tr key={colaborador.id_colaborador} id={colaborador.id_colaborador}>
                                    <td>{colaborador.nome}</td>
                                    <td>
                                        <Form.Check
                                            type="switch"
                                            className="evento"
                                            id={"evento" + colaborador.id_colaborador}
                                            label="Participou"
                                            value={colaborador.id_colaborador}
                                        />
                                    </td>
                                    <td>{colaborador.Cargo[0].nome_cargo}</td>
                                </tr>
                            ))) : (colaboradores.map(colaborador => (
                                <tr key={colaborador.id_colaborador} id={colaborador.id_colaborador}>
                                    <td>{colaborador.nome}</td>
                                    <td>
                                        <Form.Check
                                            type="switch"
                                            className="evento"
                                            id={"evento" + colaborador.id_colaborador}
                                            label="Participou"
                                            value={colaborador.id_colaborador}
                                        />
                                    </td>
                                    <td>{colaborador.Cargo[0].nome_cargo}</td>

                                </tr>
                            )))

                        }
                    </tbody>
                </Table>
                <button type="button" onClick={() => atribuicaoMultipla()} className="btn-icones rounded p-1"><Salvar /> Salvar</button>
            </div>
        </div>
    </>
}

export default AtribuicaoMilhasEventos;